<template>
  <div class="articleContainer">
    <div class="info" v-for="(item,index) in this.classifyList" :key="index">
      <!-- :class="index == 0 ? 'articleName' : ''" -->
      <div @mouseover="currMenus(item)">
        <span>{{item.parent?item.parent.name:''}}</span>
        <i class="el-icon-arrow-right iStyle"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { queryAllClassifyList } from "@/comm/api";

export default {
  name: "LeftMenus",
  components: {},
  data() {
    return {
      isShowCard: 0,
      selectIndex: 0,
      classifyList: [],
    };
  },
  created() {
    this.loadMenus();
  },
  computed: {
    getSelectIndex() {
      if (this.$store.state.userCenter.selectIndex) {
      }
      return this.selectIndex;
    },
  },
  methods: {
    loadMenus() {
      queryAllClassifyList({ type: 1 }).then((res) => {
       
        if (res.success) {
        
          this.classifyList = res.result;
          console.log(res.result);
          console.log("1111111111111111111111111111111");
        } else {
          console.log(res.message);
        }
      });
    },
    currMenus(type) {
     
      this.$emit("homeCurrMenus", type.parent);
      this.isShowCard = type.parent;
      this.$parent.secondClassify = type.children;
    },
    moveMenus() {
      this.$emit("homeMoveMenus");
    },

    selectMenus(index, type) {
      if (type == "space") {
        //  this.$router.push("/personalSpace");
        let routeData = this.$router.resolve({
          path: "/personalSpace",
          query: { id: 1 },
        });
        window.open(routeData.href, "_blank");
        return true;
      } else if (type == "creative") {
        let routeData = this.$router.resolve({
          path: "/creativeCenter",
          query: { id: 1 },
        });
        window.open(routeData.href, "_blank");
        return true;
      }
      this.selectIndex = index;
      this.$emit("chooseMenus", index);
      this.$store.commit("setSelectIndex", index);
    },
    leave() {
      this.isOver = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.articleContainer {
  width: 234px;
  height: 440px;
  align-items: center;
  // background: #5B697F; 在颜色后在增加两位可以设置透明
  background: #08072399;

  div {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 80%;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;

    i {
      height: 55px;
      line-height: 55px;
    }
  }

  .info:hover {
    background: #4f4e62;
  }

  .info {
    width: 100%;

    .articleName {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 55px;

      span {
        padding-left: 40px;
      }

      .iStyle {
        float: right;
        margin: 24px 30px 0 0;
        font-size: 12px;
      }

      &:hover {
        background: #4F4E62;
      }
    }

    .persionStyle {
      background-color: #F82B17;
      color: #FFFFFF;
      line-height: 60px;
    }

    .noneBackgroud {
      color: #333333;
      line-height: 60px;
      border-top: 1px solid #EDEEEF;
    }

    .borderStyle {
      border-bottom: 1px solid #EDEEEF;

      span {
        // width:184px;
        line-height: 20px;
        border-left: 2px solid #F82B17;
        display: inline-block;
        color: #000;
        margin-left: 0px;
      }
    }

    .readCount {
      font-size: 12px;
      font-weight: 400;
      color: #BBBBBB;
      line-height: 17px;
    }
  }
}
</style>
